import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'

const AutomotiveIndustry = ({ location }) => {
    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
    <section id="about" className="wow fadeInUp" style={{ backgroundColor: "white" }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 about-img">
            <img src="../../theme/img/automotive-1-1-1024x683.jpg" alt="Automotive Industry" />
          </div>
                        <div className="col-lg-6 content">
                            <h1 className="elementor-heading-title elementor-size-default">Automotive Industry {state.condText}</h1>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-lg-6 about-img">
            <h2 className="elementor-heading-title elementor-size-default">
              In the past, the aim was always to make long-term financial decisions to ensure stability.
            </h2>
            <p style={{ fontWeight: 400 }}>
              The automotive industry is facing a high level of revenue volatility and companies need to be ready to turn as fast as their products do.
              Today, being able to identify and act upon new trends and sales opportunities is what will give the competitive edge. In an environment
              that is rapidly shifting towards a more niche, labour-intensive style of operation, businesses need to be nimble enough to move with the
              market, while keeping a close eye on their operations to keep costs under control.
            </p>
          </div>
          <div className="col-lg-6 content">
            <img src="../../theme/img/automotive-2-1-768x512.jpg" alt="Automotive Trends" />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-lg-6 about-img">
            <img src="../../theme/img/bdimg3.JPG" alt="Tejaxo ERP" />
          </div>
          <div className="col-lg-6 content">
            <h2 className="elementor-heading-title elementor-size-default">
              Tejaxo ERP Manufacturing Management helps you deliver to market more innovative, sophisticated products...
            </h2>
            <p style={{ fontWeight: 400 }}>
              �that keep you ahead of the competition, supported by a range of quality management tools that automate production and testing so that
              quality can be delivered faster. Our ERP solutions help you to understand financial performance, with granular monitoring of production
              and enhanced cost and revenue tracking that is critical to the automotive industry.
            </p>
          </div>
        </div>
      </div>
            </section>
        </MasterPage>
  );
};

export default AutomotiveIndustry;